import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "developer-tools"
    }}>{`Developer Tools`}</h1>
    <p>{`While writing UXP scripts and plugins, the following tools will make your job easier.`}</p>
    <h2 {...{
      "id": "code-editor"
    }}>{`Code Editor`}</h2>
    <p>{`A good text editor is necessary for you to organize your project effectively. Any modern developer-friendly text editor should work, but one of the popular choices is `}<a parentName="p" {...{
        "href": "https://code.visualstudio.com"
      }}>{`Visual Studio Code`}</a>{`, which has deep integrations with the other pieces needed for UXP, and a wide variety of its plugins to help with code formatting, syntax checking, JSON parsing, and so on.`}</p>
    <h2 {...{
      "id": "uxp-developer-tool-udt"
    }}>{`UXP Developer Tool (UDT)`}</h2>
    <p>{`The Adobe UXP Developer Tool (UDT) makes it easy to create, load, manage, and debug UXP-based plugins and scripts for UXP-powered applications. `}</p>
    <p>{`Additionally, for plugins, `}</p>
    <ul>
      <li parentName="ul">{`It has a playground where you can try out and experiment with APIs`}</li>
      <li parentName="ul">{`It lets you create a `}<inlineCode parentName="li">{`.ccx`}</inlineCode>{` - A UXP plugin package ready for distribution.`}</li>
      <li parentName="ul">{`And offers a variety of easy-to-use templates and samples, to begin with.`}</li>
    </ul>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p><strong parentName="p">{`IMPORTANT`}</strong>{`:
The Adobe UXP Developer Tool requires elevated privileges to function correctly. If your administrator does not enable your ability to elevate to Administrator privileges, you'll be unable to use this tool.`}</p>
    <h3 {...{
      "id": "installation"
    }}>{`Installation`}</h3>
    <p>{`Install UDT by clicking `}<a parentName="p" {...{
        "href": "https://creativecloud.adobe.com/apps/download/uxp-developer-tools"
      }}>{`here`}</a>{` or by following these steps:`}</p>
    <ol>
      <li parentName="ol">{`Launch Adobe Creative Cloud Application. If not installed, `}<a parentName="li" {...{
          "href": "https://creativecloud.adobe.com/apps/download/creative-cloud"
        }}>{`download and install Creative Cloud`}</a>{`.`}</li>
      <li parentName="ol">{`Sign in with your Adobe account if not already signed in.`}</li>
      <li parentName="ol">{`Click on `}<inlineCode parentName="li">{`All apps`}</inlineCode>{` section, and you should see "UXP Developer Tools" listed.
`}<span parentName="li" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1280px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "display": "block",
              "transition": "opacity 0.5s 0.5s",
              "pointerEvents": "none"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/5530d/ccd-allapps-udt.webp 320w", "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/0c8fb/ccd-allapps-udt.webp 640w", "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/94b1e/ccd-allapps-udt.webp 1280w", "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/0b34d/ccd-allapps-udt.webp 1920w", "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/a8ede/ccd-allapps-udt.webp 2272w"],
              "sizes": "(max-width: 1280px) 100vw, 1280px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/dd4a7/ccd-allapps-udt.png 320w", "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/0f09e/ccd-allapps-udt.png 640w", "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/bbbf7/ccd-allapps-udt.png 1280w", "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/ac7a9/ccd-allapps-udt.png 1920w", "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/228fd/ccd-allapps-udt.png 2272w"],
              "sizes": "(max-width: 1280px) 100vw, 1280px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/indesign/uxp/static/89dc401e116c5336d84691abd1098ec5/bbbf7/ccd-allapps-udt.png",
              "alt": "Creative cloud",
              "title": "Creative cloud",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "opacity": "0",
                "transition": "opacity 0.5s",
                "color": "inherit",
                "boxShadow": "inset 0px 0px 0px 400px none",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></li>
      <li parentName="ol">{`Click on the `}<inlineCode parentName="li">{`Install`}</inlineCode>{` button for the `}<inlineCode parentName="li">{`UXP Developer Tools`}</inlineCode>{` card to start the installation.`}</li>
    </ol>
    <h3 {...{
      "id": "launching-for-the-first-time"
    }}>{`Launching for the first time`}</h3>
    <p>{`When you launch the Developer Tool for the first time, you'll be prompted to enable Developer Mode. This is required for you to load plugins in development into the application.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "55.00000000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/5530d/devmode.webp 320w", "/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/0c8fb/devmode.webp 640w", "/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/94b1e/devmode.webp 1280w", "/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/98c65/devmode.webp 1284w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/dd4a7/devmode.png 320w", "/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/0f09e/devmode.png 640w", "/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/bbbf7/devmode.png 1280w", "/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/7b3ec/devmode.png 1284w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/d925b6143a5536feb6314ffdd987eb2e/bbbf7/devmode.png",
            "alt": "Enable Developer Mode",
            "title": "Enable Developer Mode",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Once you click `}<inlineCode parentName="p">{`Enable`}</inlineCode>{`, elevated permissions will be requested, and you may be required to enter your password or approve an action from the Developer Tool.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "520px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "113.12500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/80847c882980b744163deb65d97ecd9f/5530d/macos-elevated-permissions.webp 320w", "/indesign/uxp/static/80847c882980b744163deb65d97ecd9f/29f9e/macos-elevated-permissions.webp 520w"],
            "sizes": "(max-width: 520px) 100vw, 520px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/80847c882980b744163deb65d97ecd9f/dd4a7/macos-elevated-permissions.png 320w", "/indesign/uxp/static/80847c882980b744163deb65d97ecd9f/407f2/macos-elevated-permissions.png 520w"],
            "sizes": "(max-width: 520px) 100vw, 520px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/80847c882980b744163deb65d97ecd9f/407f2/macos-elevated-permissions.png",
            "alt": "Elevated Permissions request",
            "title": "Elevated Permissions request",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span>{` `}</p>
    <p>{`If you have problems with this step, you can also configure Developer Mode manually, although you must have Administrative privileges to do so:`}</p>
    <ol>
      <li parentName="ol">{`Quit the UXP Developer Tool`}</li>
      <li parentName="ol">{`Navigate to `}<inlineCode parentName="li">{`/Library/Application Support/Adobe/UXP/Developer`}</inlineCode>{` on macOS, or `}<inlineCode parentName="li">{`%CommonProgramFiles%/Adobe/UXP/Developer`}</inlineCode>{` on Windows. (If the folder does not exist, you can create it -- you'll need administrative rights.)`}</li>
      <li parentName="ol">{`Create a new file named `}<inlineCode parentName="li">{`settings.json`}</inlineCode>{` with the following contents (You'll need administrative rights to save the file):`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-json"
          }}>{`{"developer" : true}
`}</code></pre>
      </li>
      <li parentName="ol">{`Launch the UXP Developer Tool again.`}</li>
    </ol>
    <p>{`For now, successfully installing UDT is sufficient. We will understand UDT in more depth, once you write your first script or plugin. `}</p>
    {/*
     TODO Add this section once details are available
     ## Type definitions
     Provide download link for UXP and InDesign 
     */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      